import { Fragment, useEffect } from "react";
import { useState } from "react";
import "./CustomModelInfoCard.scss";

import {
  TrashIcon,
  ToggleButtonInactiveIcon,
  ToggleButtonActiveIcon,
  PlusIcon,
  WhiteCrossIcon,
  ReportIconRectangle,
  InnerDivIcon,
  DividerLine,
} from "../SatelliteProfileImgAssets/SatelliteProfileImgAssets";
import { ButtonToolbar, OverlayTrigger } from "react-bootstrap";
import { showToastMessage, validateAngleRange, validateNumberWithoutDecimal, validateMagnitude, getCharacterLimitMessage } from "../../../../../utils/commonFunctions";
import ModalDropdown from "../../../../CommonComponents/ModalDropdown";
import { VALIDATION_RULES } from "../../../../../utils/constants";
import { CircularProgress } from "@mui/material";

const SensorInfoCard = ({
  reportProps,
  orientation,
  onOrientationChange,
  selectedSensors,
  controlModes,
  startSensorAnalysis,
  loading,
  selectedSensorHeader,
  setDuration,
  durationObject,
  duration,
  setNewSensorAnalysis,
  newSensorAnalysis
}) => {
  const [isComponentInfoCardActive, setIsComponentInfoCardActive] = useState<boolean>(true);
  const [selectedModeOption, setSelectedModeOption] = useState<any>("Sun");
  const [controlModeObjects, setControlModeObjects] = useState<any>([]);
  const [showControlModes, setShowcontrolModes] = useState(false);
  const [activeSensors, setActiveSensors] = useState<any>();
  const [selectedSensor, setSelectedSensor] = useState<any>();
  const [hoveredSensor, setHoveredSensor] = useState<any>(null);
  const [verticleFov, setVerticleFov] = useState('9')

  const handleOrientationChange = (axis, value) => {
    if (value.length > 9) {
      showToastMessage('error', getCharacterLimitMessage(9));
    } else {
      const validation = validateAngleRange(value, VALIDATION_RULES.ORIENTATION_RANGE.MIN, VALIDATION_RULES.ORIENTATION_RANGE.MAX);
      if (validation.success) {
        // Update the orientation state
        onOrientationChange({ ...orientation, [axis]: value });
      } else {
        showToastMessage('info', `The value must be between ${VALIDATION_RULES.ORIENTATION_RANGE.MIN} and ${VALIDATION_RULES.ORIENTATION_RANGE.MAX}`)
      }

    }

  };

  const InfoCardReportActions = ({ currentSensor, setSelectedSensor, selectedSensor }) => (
    <div className="infoCardReportActionsDiv">
      <div
        onClick={() => {
          setSelectedSensor(selectedSensor.filter((sensor) => sensor.name !== currentSensor.name));
        }}
      >
        <TrashIcon />
      </div>
    </div>
  );

  useEffect(() => {
    if (selectedSensors) {
      const allSelectedSensors = selectedSensors?.map((sensor) => sensor?.node || sensor);

      setControlModeObjects([]) // reseting the control mode objects to empty array
      setDuration(durationObject[0]?.label) // reseting the duration to 1st option from the dropdown list
      let activeList: any = {};
      allSelectedSensors?.map((item) => {
        if (allSelectedSensors.length === 1) {
          activeList = { [item["name"]]: true };
        } else {
          activeList = { ...activeList, [item["name"]]: false };
        }
      });
      setActiveSensors(activeList);
      setSelectedSensor(allSelectedSensors);
    }
  }, [selectedSensors]);

  const handleMassInput = (currentSensor, value) => {
    setSelectedSensor((prevSensors) =>
      prevSensors.map((sensor) =>
        sensor.name === currentSensor.name
          ? {
            ...sensor,
            value: {
              ...sensor.value,
              mass: parseFloat(value), // Update mass to the desired value
            },
          }
          : sensor
      )
    );
  };

  const handleSizeInput = (currentSensor, value) => {
    setSelectedSensor((prevSensors) =>
      prevSensors.map((sensor) =>
        sensor.name === currentSensor.name
          ? {
            ...sensor,
            value: {
              ...sensor.value,
              size: parseFloat(value), // Update mass to the desired value
            },
          }
          : sensor
      )
    );
  };

  const handleFovChange = (currentSensor, value) => {
    setSelectedSensor((prevSensors) =>
      prevSensors.map((sensor) =>
        sensor.name === currentSensor.name
          ? {
            ...sensor,
            value: {
              ...sensor.value,
              fov: parseFloat(value), // Update mass to the desired value
            },
          }
          : sensor
      )
    );
  };

  const handleExclusiveAngle = (currentSensor) => {
    setSelectedSensor((prevSensors) =>
      prevSensors.map((sensor) =>
        sensor.name === currentSensor.name
          ? {
            ...sensor,
            value: {
              ...sensor.value,
              exclusionAngleBool: !sensor.value.exclusionAngleBool,
            },
          }
          : sensor
      )
    );
  };

  const handleOrientationsChange = (currentSensor, axis, value) => {
    let currentSensorNode = currentSensor?.node || currentSensor
    setSelectedSensor((prevSensors) =>
      prevSensors.map((sensor) =>
        sensor.name === currentSensorNode?.label
          ? {
            ...sensor,
            value: {
              ...sensor.value,
              orientation:
                axis === "x"
                  ? [parseFloat(value), parseFloat(sensor.value.orientation[1]), parseFloat(sensor.value.orientation[2])]
                  : axis === "y"
                    ? [parseFloat(sensor.value.orientation[0]), parseFloat(value), parseFloat(sensor.value.orientation[2])]
                    : [parseFloat(sensor.value.orientation[0]), parseFloat(sensor.value.orientation[1]), parseFloat(value)],
            },
          }
          : sensor
      )
    );
  };

  const handleExclusiveAngles = (currentSensor, angle, value) => {
    setSelectedSensor((prevSensors) =>
      prevSensors.map((sensor) =>
        sensor.name === currentSensor.name
          ? {
            ...sensor,
            value: {
              ...sensor.value,
              exclusionAngleSunEarthMoon:
                angle === "sun"
                  ? [parseFloat(value), parseFloat(sensor.value.exclusionAngleSunEarthMoon[1]), parseFloat(sensor.value.exclusionAngleSunEarthMoon[2])]
                  : angle === "earth"
                    ? [parseFloat(sensor.value.exclusionAngleSunEarthMoon[0]), parseFloat(value), parseFloat(sensor.value.exclusionAngleSunEarthMoon[2])]
                    : [parseFloat(sensor.value.exclusionAngleSunEarthMoon[0]), parseFloat(sensor.value.exclusionAngleSunEarthMoon[1]), parseFloat(value)],
            },
          }
          : sensor
      )
    );
  };

  const removeControlMode = (itemToDelete) => {
    const title = itemToDelete.title;
    const name = itemToDelete.value?.name;
    const matchingTitleItems = controlModeObjects.filter(item => item.title === title);
    let itemRemoved = false;
    const updatedControlModeObjects = controlModeObjects.filter(item => {
      if (!itemRemoved && item.value?.name === name) {
        itemRemoved = true;
        return false; // Remove this item
      }
      if (!itemRemoved && matchingTitleItems.length > 1 && item.title === title) {
        itemRemoved = true;
        return false; // Remove one of the matching titles
      }
      return true; // Keep this item
    });
    setControlModeObjects(updatedControlModeObjects);
  };

  const setStartSensorAnalysisData = () => {
    if (loading) {
      return;
    }
    let controlModess: any = [];
    controlModeObjects?.map((controlMode: any) => {
      controlModess.push(controlMode.value);
    });
    if (controlModess.length === 0) {
      showToastMessage('info', 'Please Add Control Mode')
      return;
    }
    let allSensors: any = [];
    selectedSensor?.map((sensors) => {
      allSensors.push(sensors.value);
    });

    if (allSensors?.length === 0) {
      showToastMessage('info', 'Please add at least one sensor for analysis');
      return;
    }
    let data = {
      entity: selectedModeOption,
      duration: parseFloat(duration),
      controlModes: controlModess,
      sensorsConfigurations: allSensors,
    };
    setNewSensorAnalysis(true);
    startSensorAnalysis(data);
  }

  const handleSunEarthAngleChange = (value, currentSensor, entity) => {
    if (value.length > 9) {
      showToastMessage('error', getCharacterLimitMessage(9))
    } else {
      const validation = validateAngleRange(value, VALIDATION_RULES.ANGLE_RANGE.MIN, VALIDATION_RULES.ANGLE_RANGE.MAX);
      if (validation.success) {
        handleExclusiveAngles(currentSensor, entity, value);
      } else if (validation.error) {
        showToastMessage('info', `The value must be between ${VALIDATION_RULES.ANGLE_RANGE.MIN}° and ${VALIDATION_RULES.ANGLE_RANGE.MAX}°`)
      }
    }
  }

  const validateFOV = (value) => {
    if (value.length > 9) {
      showToastMessage('error', getCharacterLimitMessage(9))
    } else {
      const validation = validateAngleRange(value, VALIDATION_RULES.ANGLE_RANGE.MIN, VALIDATION_RULES.ANGLE_RANGE.MAX);
      if (validation.success) {
        setVerticleFov(value)
      } else if (validation.error) {
        showToastMessage('info', `The value must be between ${VALIDATION_RULES.ANGLE_RANGE.MIN}° and ${VALIDATION_RULES.ANGLE_RANGE.MAX}°`)
      }
    }
  }

  useEffect(() => {
    const overlayClose = () => {
      setShowcontrolModes(false);
    }
    window.addEventListener("click", overlayClose)
    return () => {
      window.removeEventListener("click", overlayClose)
    }
  }, [])

  const disabledButton = (newSensorAnalysis, controlModeObjects, controlModes) => {
    let allnames: string[] = []
    let selectedNames: string[] = []
    controlModeObjects?.length && controlModeObjects.map(obj => { !allnames.includes(obj?.title) && allnames.push(obj?.title) })
    controlModes?.length && controlModes.map(obj => { !selectedNames.includes(obj?.name) && selectedNames.push(obj?.name) })
    return newSensorAnalysis || (allnames?.length === selectedNames?.length)
  }

  const orientationValue = (input: string): string => {
    const parsedValue = parseFloat(input);
    if (input === '') {
      return '';
    }
    else if (parsedValue > 1) {
      return '1';
    } else if (parsedValue < -1) {
      return '-1';
    } else {
      return parsedValue.toString();
    }
  };

  return (
    <div className={`custom-model-infocard overflow-hidden ${isComponentInfoCardActive ? "active" : ""} ${reportProps?.isReportBarOpen ? "isReportOpen" : ""}`}
      style={{ position: 'absolute' }}
      id="create_model_infocard">
      <div className="infocard-content-wrapper">
        {selectedSensorHeader &&
          <div className="infocard-label-div position-style">
            {selectedSensorHeader}
          </div>
        }
        <div className="custom-model-infocard-inner-div" >
          <div style={selectedSensorHeader ? { padding: "8px 4px 4px" } : { padding: "0px" }}>
            {selectedSensor &&
              selectedSensor?.map((currentSensor) => (
                <div className="current-sensor-div">
                  <div
                    className={`${selectedSensorHeader ? "infocard-label-div individual-label-div" : "infocard-label-div"} ${activeSensors[currentSensor?.name] ? "active" : ""}`}
                    onMouseEnter={() => setHoveredSensor(currentSensor.name)}
                    onMouseLeave={() => setHoveredSensor(null)}
                    onClick={() => {
                      if (selectedSensor?.length === 1) return; // Disable toggle if individual sensor is selected
                      setActiveSensors({
                        ...activeSensors,
                        [currentSensor.name]: !activeSensors[currentSensor.name],
                      });
                    }}
                  >
                    <span className="infocard-component-label">{currentSensor.name ?? currentSensor?.node?.label}</span>
                    {/** currently not integrating this */}
                    {/* Only show InfoCardReportActions if the current div is hovered */}
                    {/* {hoveredSensor === currentSensor.name && (
                    <InfoCardReportActions currentSensor={currentSensor} setSelectedSensor={setSelectedSensor} selectedSensor={selectedSensor} />
                  )} */}
                  </div>
                  {((selectedSensor?.length === 1 && currentSensor.name === selectedSensor[0]?.name) ||
                    (selectedSensor?.length > 1 && activeSensors?.[currentSensor?.name])) && (
                      <div className={`infocard-properties-div ${selectedSensorHeader ? 'with-border' : ''} ${newSensorAnalysis ? 'disabled-button' : ''}`}>
                        <div className="infocard-component-properties-div">
                          <div className="infocard-component-properties-div">
                            <div className="infocard-component-properties-sub-div">
                              <span className="infocard-units-location-span">{"Mass"}</span>
                              <div className="infocard-units-location-sub-div">
                                <div className="infocard-component-togglebtn-div">
                                  <div className="infocard-component-value-div">
                                    <input
                                      className="infocard-location-value read-only-input"
                                      type="number"
                                      onChange={(e) => {
                                        handleMassInput(currentSensor, e.target.value);
                                      }}
                                      value={currentSensor?.value?.mass ? currentSensor?.value?.mass : 0}
                                      readOnly
                                    ></input>
                                  </div>
                                  <div className="infocard-component-units-div">
                                    <span className="infocard-location-y-axis">{"g"}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* As currently we do not have predefined size for Sun Sensor*/}
                          {!currentSensor?.name?.includes('Sun Sensor') &&
                            <div className="infocard-component-properties-div">
                              <div className="infocard-component-properties-sub-div">
                                <span className="infocard-units-location-span">{"Size"}</span>
                                <div className="infocard-units-location-sub-div">
                                  <div className="infocard-component-togglebtn-div">
                                    <div className="infocard-component-value-div">
                                      <input
                                        className="infocard-location-value read-only-input"
                                        type="number"
                                        onChange={(e) => {
                                          handleSizeInput(currentSensor, e.target.value);
                                        }}
                                        value={currentSensor?.value?.size ? currentSensor?.value?.size : 0}
                                        readOnly
                                      ></input>
                                    </div>
                                    <div className="infocard-component-units-div">
                                      <span className="infocard-location-y-axis">{"U"}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                          <div className="greenModalFooter"></div>
                          <DividerLine />
                          <div className="infocard-units-location-value-div">
                            <span className="infocard-units-location-span">Vector</span>
                            <div className="infocard-three-inputs-div">
                              <div className="infocard-location-div">
                                <div className="infocard-location-value-div">
                                  <input
                                    type="number"
                                    className={`infocard-location-value text-truncate `}
                                    value={orientation.x}
                                    title={orientation.x}
                                    onChange={(e) => {
                                      let rawInput: string = e?.target?.value;
                                      let parsedValue = parseFloat(rawInput);
                                      const inputValue = orientationValue(rawInput);
                                      handleOrientationsChange(currentSensor, "x", inputValue);
                                      handleOrientationChange("x", inputValue);
                                    }}
                                  />
                                </div>
                                <div className="infocard-location-x-axis-div">
                                  <span className="infocard-location-x-axis">x</span>
                                </div>
                              </div>
                              <div className="infocard-location-div">
                                <div className="infocard-location-value-div">
                                  <input
                                    type="number"
                                    className={`infocard-location-value  text-truncate `}
                                    value={orientation.y}
                                    title={orientation.y}
                                    onChange={(e) => {
                                      let rawInput: string = e?.target?.value;
                                      let parsedValue = parseFloat(rawInput);
                                      const inputValue = orientationValue(rawInput);
                                      handleOrientationsChange(currentSensor, "y", inputValue);
                                      handleOrientationChange("y", inputValue);
                                    }}
                                  />
                                </div>
                                <div className="infocard-location-x-axis-div">
                                  <span className="infocard-location-y-axis">y</span>
                                </div>
                              </div>
                              <div className="infocard-location-div">
                                <div className="infocard-location-value-div">
                                  <input
                                    type="number"
                                    className={`infocard-location-value text-truncate`}
                                    value={orientation.z}
                                    title={orientation.z}
                                    onChange={(e) => {
                                      let rawInput: string = e?.target?.value;
                                      let parsedValue = parseFloat(rawInput);
                                      const inputValue = orientationValue(rawInput);
                                      handleOrientationsChange(currentSensor, "z", inputValue);
                                      handleOrientationChange("z", inputValue);
                                    }}
                                  />
                                </div>
                                <div className="infocard-location-x-axis-div">
                                  <span className="infocard-location-z-axis">z</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          {<div className="infocard-component-properties-div">
                            <div className="infocard-component-properties-sub-div">
                              <span className="infocard-units-location-span">{selectedSensor?.[0]?.value?.sensorType === 'Sun Sensor' ? "FOV" : "Horizontal FOV"}</span>
                              <div className="infocard-units-location-sub-div">
                                <div className="infocard-component-togglebtn-div">
                                  <div className="infocard-component-value-div">
                                    <input
                                      className={`infocard-location-value text-truncate read-only-input`}
                                      type="number"
                                      onChange={(e) => {
                                        handleFovChange(currentSensor, e.target.value);
                                      }}
                                      // value={currentSensor?.value?.fov}
                                      // Since for now the FOV for sun sensor is not editatble so setting FOV to default value - 100 
                                      value="10"
                                      readOnly
                                    ></input>
                                  </div>
                                  <div className="infocard-component-units-div">
                                    <span className="infocard-location-y-axis">{"deg"}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {selectedSensor?.[0]?.value?.sensorType !== 'Sun Sensor' && <div className="infocard-component-properties-sub-div">
                              <span className="infocard-units-location-span">{"Vertical FOV"}</span>
                              <div className="infocard-units-location-sub-div">
                                <div className="infocard-component-togglebtn-div">
                                  <div className="infocard-component-value-div">
                                    <input
                                      className={`infocard-location-value text-truncate`}
                                      type="number"
                                      onChange={(e) => {
                                        validateFOV(e.target.value);
                                      }}
                                      value={verticleFov}
                                      title={verticleFov}
                                    ></input>
                                  </div>
                                  <div className="infocard-component-units-div ">
                                    <span className="infocard-location-y-axis">{"deg"}</span>
                                  </div>
                                </div>
                              </div>
                            </div>}
                          </div>}

                          {selectedSensor?.[0]?.value?.sensorType !== 'Sun Sensor' && < div className="infocard-component-properties-div">
                            <div className="infocard-component-properties-sub-div not-space-between">
                              <span className="infocard-units-location-span">Exclusion Angle</span>
                              <div className={`infocard-units-location-sub-div `}>
                                <button
                                  onClick={() => {
                                    setShowcontrolModes(false)
                                    handleExclusiveAngle(currentSensor);
                                  }}
                                >
                                  {currentSensor?.value?.exclusionAngleBool ? <ToggleButtonActiveIcon /> : <ToggleButtonInactiveIcon />}
                                </button>
                              </div>
                            </div>
                          </div>}
                        </div>

                        {currentSensor?.value?.exclusionAngleBool && (
                          <>
                            <div className="infocard-component-properties-div">
                              <div className="infocard-component-properties-sub-div">
                                <span className="infocard-units-location-span">{"Sun"}</span>
                                <div className="infocard-units-location-sub-div">
                                  <div className="infocard-component-togglebtn-div">
                                    <div className="infocard-component-value-div">
                                      <input
                                        className={`infocard-location-value text-truncate`}
                                        type="number"
                                        onChange={(e) => {
                                          handleSunEarthAngleChange(e.target.value, currentSensor, "sun")
                                        }}
                                        value={currentSensor?.value?.exclusionAngleSunEarthMoon[0]}
                                        title={currentSensor?.value?.exclusionAngleSunEarthMoon[0]}
                                      ></input>
                                    </div>
                                    <div className="infocard-component-units-div">
                                      <span className="infocard-location-y-axis">{"deg"}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* {currentSensor?.value?.sensorType !== 'payload' && <div className="infocard-component-properties-div">
                          <div className="infocard-component-properties-sub-div">
                            <span className="infocard-units-location-span" style={{ opacity: 0.6 }}>{"Moon"}</span>
                            <div className="infocard-units-location-sub-div">
                              <div className="infocard-component-togglebtn-div">
                                <div className="infocard-component-value-div">
                                  <input
                                    className="infocard-location-value" style={{ opacity: 0.6 }}
                                    type="number"
                                    onChange={(e) => {
                                      handleExclusiveAngles(currentSensor, "moon", e.target.value);
                                    }}
                                    value={currentSensor?.value?.exclusionAngleSunEarthMoon[2]}
                                    readOnly
                                  ></input>
                                </div>
                                <div className="infocard-component-units-div">
                                  <span className="infocard-location-y-axis">{"deg"}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>} */}
                            {currentSensor?.value?.sensorType !== 'payload' && <div className="infocard-component-properties-div">
                              <div className="infocard-component-properties-sub-div">
                                <span className="infocard-units-location-span">{"Earth"}</span>
                                <div className="infocard-units-location-sub-div">
                                  <div className="infocard-component-togglebtn-div">
                                    <div className="infocard-component-value-div">
                                      <input
                                        className={`infocard-location-value text-truncate `}
                                        type="number"
                                        onChange={(e) => {
                                          handleSunEarthAngleChange(e.target.value, currentSensor, "earth")
                                        }}
                                        value={currentSensor?.value?.exclusionAngleSunEarthMoon[1]}
                                        title={currentSensor?.value?.exclusionAngleSunEarthMoon[1]}
                                      ></input>
                                    </div>
                                    <div className="infocard-component-units-div">
                                      <span className="infocard-location-y-axis">{"deg"}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>}
                            <div className="greenModalFooter"></div>
                          </>
                        )}
                      </div>
                    )}
                </div>
              ))}
          </div>
          {/* <div className="greyScrollableSectionBar gap-2"> */}
          {!reportProps?.isReportBarOpen && <div className="infocard-label-div valid-crit-div">Simulation Details
            <div className="report_icon_wrapper">
              <ReportIconRectangle />
            </div>
          </div>}
          <div className="infocard-properties-div" style={{ paddingBottom: "0px" }}>
            <div className="infocard-component-properties-div">
              <div className="infocard-component-properties-div">
                <div className="infocard-component-properties-sub-div">
                  <span className="infocard-units-location-span">{"Duration"}</span>
                  <div className={`dropdownBodyItemText`}>
                    {
                      <ModalDropdown
                        options={durationObject}
                        isMulti={false}
                        handleSelectedOption={(e) => {
                          setShowcontrolModes(false)
                          setDuration(e.label);
                        }}
                        previousOption={duration}
                        isSensorAnalysis={true}
                      />
                    }
                  </div>

                </div>
              </div>
            </div>

            <div className="infocard-component-properties-div">
              <div className="infocard-component-properties-sub-div">
                <span className="infocard-units-location-span">Control Mode</span>
              </div>
            </div>

            <div className="infocard-component-properties-div controlModeObjectsDiv">
              {controlModeObjects &&
                controlModeObjects?.map((item) => (
                  <div className="controlModeObjectsButton">
                    <button className="controlModeObjectsButton">{item.title}</button>
                    <button
                      className={`controlModeObjectsButton`}
                      onClick={() => {
                        if (!newSensorAnalysis) {
                          removeControlMode(item);
                        }
                      }}
                      disabled={newSensorAnalysis}
                    >
                      <WhiteCrossIcon />
                    </button>
                  </div>
                ))}

              <div className="position - relative ">
                <ButtonToolbar>
                  <OverlayTrigger placement="top-start" trigger='click' show={showControlModes}
                    overlay={(
                      <div className={`control__mode__dropdown__container background_blur_dropdown ${newSensorAnalysis ? 'disabled-button' : ''}`}>
                        {controlModes?.map((mode) => {
                          const isAlreadySelected = controlModeObjects?.some(obj => obj.title === mode.name);
                          return (
                            <button
                              key={mode.name}
                              onClick={() => {
                                if (!isAlreadySelected) {
                                  if (controlModeObjects && controlModeObjects.length < 12) {
                                    setShowcontrolModes(false);
                                    setControlModeObjects([
                                      ...controlModeObjects,
                                      { title: mode.name, value: mode }
                                    ]);
                                  } else {
                                    showToastMessage("info", "Maximum 12 control modes allowed");
                                  }
                                }
                              }}
                              className={`dropdown__item__container ${isAlreadySelected ? 'disabled' : ''}`}
                            >
                              <div className="dropdown__item__title_container" title={mode.name}>
                                <span className="dropdown__item__title">{mode.name}</span>
                              </div>
                              <span className="dropdown__item__details">
                                {mode.attitude ? (
                                  `${mode.orientation?.join(", ")} deg`
                                ) : (
                                  <span>
                                    Sun |{"  "}
                                    <span className="infocard-location-x-axis">X </span> {mode.orientation?.[0]},{" "}
                                    <span className="infocard-location-y-axis">Y </span> {mode.orientation?.[1]},{" "}
                                    <span className="infocard-location-z-axis">Z </span> {mode.orientation?.[2]}
                                  </span>
                                )}
                              </span>
                            </button>
                          );
                        })}
                      </div>
                    )}>
                    <button
                      disabled={disabledButton(newSensorAnalysis, controlModeObjects, controlModes)}
                      className={`controlModeObjectsButton add_control_mode_icon`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowcontrolModes(!showControlModes)
                      }}>
                      <PlusIcon />
                    </button>
                  </OverlayTrigger>
                </ButtonToolbar>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Analysis button code */}
      <div className="analysis_button_wrapper">
        <button className={`analysis_button_container ${loading ? 'loading' : ''}`} onClick={() => {
          setStartSensorAnalysisData()
        }}>
          <div className={`analysis_button ${loading ? 'loading' : ''}`} />
          {!loading ? <InnerDivIcon /> : <CircularProgress size={20} color="inherit" />}
        </button>
      </div>
    </div>
  );
};

export default SensorInfoCard;
